import { SubscriptionInverseSvg } from "@/components/Icon/Icon";
import { StatusBanner } from "@/components/StatusBanner/StatusBanner";
import { useTheme } from "@mui/material";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";

export const BetaTestBanner = forwardRef<HTMLDivElement>(function BetaTestBanner(_, ref) {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <div ref={ref}>
      <StatusBanner
        open={true}
        closable={false}
        icon={<SubscriptionInverseSvg style={{ minWidth: "24px" }} color={theme.palette.info.main} />}
        variant="info"
        message={t("message.betaTest")}
        borderTop
      />
    </div>
  );
});
